




































import { Component, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import Decisions from "@/store/modules/Decisions";
import ManageUsers from '@/views/Users/ManageUsers.vue';

const decisionsModule = getModule(Decisions);

@Component({
    components: {
        ManageUsers
    }
})
export default class MembersManager extends Vue {
    @Prop({type: String})
    queryDecisionId!: string;

    @Prop({default:true, type: Boolean})
    pageStyle!: boolean

    @Prop({default:true, type: Boolean})
    showSelector!: boolean

    private decisionLoaded = false;
    private chosenDecision = '';
    private notFound = true;

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get decisions() {
        return Object.values(decisionsModule.decisions)
    }

    mounted() {
        this.initialize();
    }

    async initialize() {
        await decisionsModule.fetchDecisions();
        if (this.queryDecisionId) {
            await decisionsModule.selectDecision(this.queryDecisionId);
            this.decisionLoaded = true;
            if (!this.selectedDecision) {
                let searchedDecision = await VIEWPOINT_API.getDecision(this.queryDecisionId);
                if (searchedDecision) {
                    this.notFound = false;
                }
            }
        }
    }

    private async updateDecision(val) {
        this.decisionLoaded = false;
        await decisionsModule.selectDecision(val);
        this.decisionLoaded = true;
    }
}

